class ComponentFaqs extends TabsComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.initSearch();
  }

  initSearch() {
    this.input = this.querySelector('[data-search]');
    this.data = JSON.parse(
      this.querySelector('[data-accordions-data]').textContent || []
    );
    this.template = this.querySelector('template');
    this.resultsWrapper = this.querySelector('[data-results]');
    this.tabs = this.querySelector('.tabs-wrapper');
    this.tabsNav = this.querySelector('.tabs-nav');

    if (!this.input) return;

    this.input.addEventListener(
      'input',
      this.handleOnSearchInputChange.bind(this)
    );
  }

  handleOnSearchInputChange(event) {
    const inputValueLowerCase = event.target.value.toLowerCase();
    const matches = this.data.filter(
      (entry) =>
        entry.title.toLowerCase().includes(inputValueLowerCase) ||
        entry.content.toLowerCase().includes(inputValueLowerCase)
    );
    this.resultsWrapper.classList.toggle('hidden', event.target.value === '');
    this.tabsNav.classList.toggle('hidden', event.target.value !== '');
    this.tabs.classList.toggle('hidden', event.target.value !== '');
    this.renderResults(matches);
  }

  renderResults(results) {
    this.resultsWrapper.innerHTML = '';

    if (results.length === 0) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector(
          'template[data-empty]'
        ).content.firstElementChild.cloneNode(true)
      );

      this.resultsWrapper.appendChild(content.firstChild);

      return;
    }

    results.forEach((result) => {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector(
          'template[data-item]'
        ).content.firstElementChild.cloneNode(true)
      );
      const accordion = content.firstChild;

      accordion.querySelector('[data-title]').textContent = result.title;
      accordion.querySelector('[data-content]').innerHTML = result.content;

      this.resultsWrapper.appendChild(accordion);
    });
  }
}

customElements.define('component-faqs', ComponentFaqs);
